import { Box, styled } from '@mui/material';

export const StyledDurationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[50],
}));
